/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import { useMutation, useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import {
  EXPORTS_GRADE,
  GRADES_REQUEST,
  GRADES_REQUEST_SUBSCRIPTION,
  UPDATE_GRADE_STATUS,
} from 'pages/Products/ProductsGraphQL';
import { gradeColumns } from 'pages/Products/constant';
import StatusFormatter from 'components/StatusFormatter';
import Loader from 'components/common/Loader';
import {
  ADD_EDIT_CONSTANT,
  PRODUCT_STATUS,
  USER_ID,
  defaultDeleteFilter,
  handleStatusColor,
  showSequenceNumber,
} from 'utils/constants';
import { STATUS_UPDATED_SUCCESSFULLY } from 'components/common/FSBToastify/types';
import { toast } from 'react-toastify';
import { setUserDetails } from 'actions/userDetailsAction';
import { useDispatch } from 'react-redux';
import { cloneDeep, isEmpty } from 'lodash';
import CategoryGradeDetails from 'components/Drawers/components/CategoryDetailsDrawer/components/CategoriesDetails/components/CategoryGradeDetails';
import FSBModal from 'components/common/FSBModal';
import DownloadCSV from 'components/DownloadCSV';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import ActionsFormatter from 'components/ActionsFormatter';
import ButtonV2 from 'components/common/ButtonV2';
import { axiosPost } from 'services';
import { authContext } from 'contexts/AuthContext';
import ProductMobileList, {
  buildProductAuditSection,
  createdAtDetail,
} from 'pages/Products/components/ProductMobileList';

const CombinedGradeTable = ({ searchString, handleClickEdit }) => {
  const dispatch = useDispatch();
  const { auth } = useContext(authContext);

  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'name',
        // joinAttributeName: '',
        value: searchString,
        type: 'STRING',
        op: 'LIKE',
      },
      { ...defaultDeleteFilter },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
  });
  const [showCategoryGradeDetails, setShowCategoryGradeDetails] = useState({
    status: false,
    row: '',
  });
  const toggleShowDetails = (row) => {
    setShowCategoryGradeDetails({
      status: !showCategoryGradeDetails.status,
      row,
    });
  };
  const [showDeleteRecord, setDeleteRecord] = useState(false);

  const { data, loading, error, refetch, subscribeToMore } = useQuery(
    GRADES_REQUEST,
    {
      variables: {
        ...filters,
        filter: [...filters.filter],
      },
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    const unsubscribe = subscribeToMore({
      document: GRADES_REQUEST_SUBSCRIPTION,
      variables: { ...filters },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.grades.grades.findIndex(
          (val) => val.id === subscriptionData.data?.grades?.grade?.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (!subscriptionData.data?.grades?.grade?.id) return prev;
        if (subscriptionData.data.grades.action === 'CREATED') {
          const newGrades = subscriptionData.data.grades.grade;
          const updatedGrades = [newGrades, ...newData.grades.grades];

          const newTotalCount = prev.grades.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.grades = {
            ...newData.grades,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            grades: updatedGrades,
          };
        }
        if (subscriptionData.data.grades.action === 'UPDATED') {
          newData.grades.grades[indexFound] =
            subscriptionData.data.grades.grade;
        }

        if (subscriptionData.data.grades.action === 'DELETED') {
          const { id } = subscriptionData.data.grades.grade; // ID of the grade to remove
          const prevGrades = prev.grades.grades;

          const updatedGrades = prevGrades.filter((val) => val.id !== id);

          const newTotalCount = prev.grades.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedGradesData = {
            ...newData.grades,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            grades: updatedGrades,
          };
          newData.grades = updatedGradesData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  const [updateGradeStatus] = useMutation(UPDATE_GRADE_STATUS, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success(STATUS_UPDATED_SUCCESSFULLY);
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message }) => {
        toast.error(message);
      });
    },
  });

  const toggleDeleteRecord = () => {
    setDeleteRecord(!showDeleteRecord);
  };

  const onDeleteConfirmation = () => {
    // await deleteUser({
    //   variables: {
    //     id: id ? [id] : rowId,
    //     email: email ? [email] : rowEmail,
    //   },
    // });

    setDeleteRecord(false);
  };

  const handleStatusChange = async (e, cell) => {
    try {
      await updateGradeStatus({
        variables: { id: cell?.row?.original?.id, status: e.target.value },
      });
      refetch();
    } catch (err) {
      toast.error(err);
    }
  };

  const statusFormatter = (cell) => {
    return (
      <StatusFormatter
        options={PRODUCT_STATUS}
        defaultValue={cell?.row?.original?.status}
        handleChange={(e) => handleStatusChange(e, cell)}
        isStatus
        style={{ width: '100px' }}
        handleSelectColor={handleStatusColor}
      />
    );
  };
  const linkFormatter = (cell) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() => toggleShowDetails(cell?.row?.original)}
        aria-hidden
      >
        {cell?.row?.original?.name}
      </div>
    );
  };

  const handleUserId = (row, id) => {
    dispatch(setUserDetails({ status: true, selectedUser: { ...row, id } }));
  };

  const linkFormatterForUserId = (cell, userId) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() =>
          handleUserId(cell?.row?.original, cell?.row?.original?.[userId])
        }
        aria-hidden
      >
        {cell?.row?.original?.[userId]}
      </div>
    );
  };

  const actionsFormatter = (cell) => {
    return (
      <ActionsFormatter
        isView={false}
        isDelete={false}
        // handleDelete={() => toggleDeleteRecord(cell?.row?.original?.id)}
        // handleView={() => toggleShowDetails(cell?.row?.original)}
        handleEdit={() =>
          handleClickEdit(cell?.row?.original, ADD_EDIT_CONSTANT.EDIT, refetch)
        }
      />
    );
  };

  const findIndexOfItem = (item) => {
    return gradeColumns.findIndex((itm) => itm.accessorKey === item);
  };

  const triggerBase64Download = (base64, filename = 'downloaded-file') => {
    const byteCharacters = atob(base64);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0),
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url); // Clean up
  };

  const downloadFile = async (url, fileName) => {
    try {
      const resp = await axiosPost(
        `${process.env.REACT_APP_REST_API_ENDPOINT}common/download-file`,
        { url },
        {},
        auth,
      );
      triggerBase64Download(
        resp?.data.base64,
        `${fileName || 'TDS_SHEET'}.${url.split('.').pop()}`,
      );
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const downloadSpecSheet = (cell) => {
    return cell?.row?.original?.specsSheet?.length > 0 ? (
      <ButtonV2
        color="primary"
        type="primary"
        style={{ fontSize: '12px' }}
        size="sm"
        onClick={() => {
          downloadFile(
            cell?.row?.original?.specsSheet[0],
            cell?.row?.original?.name,
          );
        }}
      >
        Download TDS
      </ButtonV2>
    ) : (
      '-'
    );
  };

  gradeColumns[findIndexOfItem('specSheet')].cell = downloadSpecSheet;

  gradeColumns[findIndexOfItem('actions')].cell = actionsFormatter;
  gradeColumns[findIndexOfItem('status')].cell = statusFormatter;
  gradeColumns[findIndexOfItem('name')].cell = linkFormatter;
  gradeColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);
  gradeColumns[findIndexOfItem(USER_ID.CREATED_ID)].cell = (cell) =>
    linkFormatterForUserId(cell, USER_ID.CREATED_ID);
  gradeColumns[findIndexOfItem(USER_ID.UPDATED_ID)].cell = (cell) =>
    linkFormatterForUserId(cell, USER_ID.UPDATED_ID);

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  useEffect(() => {
    const updatedFilter = [...filters.filter]; // Clone the filter array
    const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
    updatedFirstFilter.value = searchString;
    updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
    // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
    refetch({ ...filters, filter: updatedFilter });
  }, [searchString]);

  const onGlobalSearch = (str) => {
    if (str) {
      setFilters((prevFilter) => {
        const updatedFilter = [...prevFilter.filter]; // Clone the filter array
        const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
        updatedFirstFilter.value = str;
        updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
        return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
      });
    }
  };

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.grades?.grades)
    return <NoDataFound message="Grades not available" />;

  return (
    <>
      <FSBModal
        size="xl"
        title="Category Grade Details"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showCategoryGradeDetails.status}
        toggleAlert={toggleShowDetails}
        onClose={toggleShowDetails}
        modalClass="right-drawer right-drawer-details"
      >
        <CategoryGradeDetails
          categoryGradeDetails={showCategoryGradeDetails.row}
        />
      </FSBModal>
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />
      <DownloadCSV
        lazyQuery={EXPORTS_GRADE}
        filters={filters}
        apiKey="exportGrades"
        fileName="AllGrades"
        positionTop="-34px"
        positionRight="38px"
        classWrapper="products-download-btn"
      />

      <ProductMobileList
        items={(data && data?.grades?.grades) || []}
        totalPages={(data && data?.grades?.totalPages) || 0}
        currentPageNo={filters.pageNo}
        pageSize={filters.pageSize}
        handlePageChange={handlePageChange}
        getTitle={(item) => item?.name || 'N/A'}
        getMeta={(item) =>
          `ID ${item?.id || 'N/A'} | ${item?.subCategory?.name || 'N/A'}`
        }
        getSections={(item, index) => ({
          Overview: [
            { label: 'Sector', value: item?.subCategory?.name || 'N/A' },
            { label: 'MFI', value: item?.mfi || 'N/A' },
            { label: 'Type', value: item?.gradeType || 'N/A' },
            createdAtDetail(item),
            {
              label: 'Status',
              value: statusFormatter({ row: { original: item, index } }),
              control: true,
            },
          ],
          Details: [
            {
              label: 'Polymer',
              value: item?.subCategory?.productSubCategory || 'N/A',
            },
            {
              label: 'Manufacturer',
              value: item?.productSubCategoryManufacturer || 'N/A',
            },
            { label: 'Application', value: item?.applications || 'N/A' },
            {
              label: 'TDS Sheet',
              value: downloadSpecSheet({ row: { original: item } }),
              control: true,
            },
          ],
          Audit: buildProductAuditSection(item),
        })}
        onTitleClick={toggleShowDetails}
        renderActions={(item) => actionsFormatter({ row: { original: item } })}
        handleUserId={handleUserId}
      />
      <div className="product-mobile-hide-table">
        <FSBTable
          data={(data && data?.grades?.grades) || []}
          totalCount={(data && data?.grades?.totalCount) || 0}
          totalPages={(data && data?.grades?.totalPages) || 0}
          columns={gradeColumns}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          globalSearchStr={filters.filter[0].value}
          onGlobalSearch={onGlobalSearch}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search Vendors"
        />
      </div>
    </>
  );
};
export default CombinedGradeTable;
